export const selectData = state => state?.data
export const selectIdentifiers = state => state?.identifiers
export const selectTalentIdentifiers = state => state?.talentIdentifiers
export const selectHasFetched = state => state?.hasFetched
export const selectIsLoading = state => state?.isLoading
export const selectLoadingError = state => state?.loadingError
export const selectSelectedHash = state => state?.selectedHash
export const selectClone = state => state?.clone

export const selectPrerequisiteHashParam = (state, { prerequisiteHash }) =>
    prerequisiteHash

export const selectIsFilterByNotificationPrerequisites = (
    state,
    { filterByNotification },
) => !!filterByNotification
